<template>
  <el-card class="iot-person public-page-style iot-search-header">
    <div slot="header">
      <el-form :inline="true" :model="getForm">
        <el-form-item>
          <el-input
            size="small"
            clearable
            v-model="getForm.industryName"
            placeholder="请输入要查询的行业名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" plain @click="checkTable()"
            >查询</el-button
          >
        </el-form-item>
        <el-button
          type="primary"
          size="mini"
          class="iot-industry-create"
          @click="addindustry()"
          >新增行业</el-button
        >
      </el-form>
    </div>
    <div style="width:100%;height:678px;overflow-y: auto;">
      <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ background: theme.TABLE_HEADER_COLOR }"
    >
      <el-table-column prop="industryId" label="ID"></el-table-column>
      <el-table-column prop="industryName" label="行业名称"></el-table-column>
      <el-table-column prop="createTime" label="开始时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="edit(scope.row.industryId)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="del(scope.row.industryId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
      
    </el-table>
    </div>
    
   <div class="page">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
        :total="total"
        :page-size="getForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        @prev-click="
          () => {
            $set(getForm, 'current', getForm.current - 1);
            getList();
          }
        "
        @next-click="
          () => {
            $set(getForm, 'current', getForm.current + 1);
            getList();
          }
        "
      >
      </el-pagination>
    </div>
    <el-dialog
    top="3%"
      title="填写表单"
      :show-close="false"
      :visible.sync="industryDialogVisinbile"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
    >
      <el-form
        :model="industryForm"
        ref="subRef"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="行业名称" label-width="120" prop="industryName">
          <el-input
            v-model="industryForm.industryName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="industryDialogVisinbile = false">取 消</el-button>
        
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { TABLE_HEADER_COLOR } from "../util/theme";
let that;
export default {
  name: "Industry",
  props: {
    msg: String,
  },
  data() {
    return {
      theme: { TABLE_HEADER_COLOR },
      tableData: [],
      getForm: {
        current: 1,
        size: 10,
        industryName: "",
      },
      total: 0,
      industryDialogVisinbile: false,
      industryForm: {
        industryName: "",
        industryId: "",
      },
      isCreate: true,
      rules: {
        industryName: [
          { required: true, message: "请输入行业名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleSizeChange(val) {
        that.getForm.size=val;
        that.getList();
      },
      handleCurrentChange(val) {
        that.getForm.current=val;
        that.getList();
      },
    getList: function () {
      that.$api.industry.getListData(that.getForm).then((response) => {
        that.tableData = response.data.records;
        that.total = response.data.total;
      });
    },
    handleClose: function () {
      that.industryDialogVisinbile = false;
    },
    addindustry: function () {
      that.industryDialogVisinbile = true;
      that.isCreate = true;
    },
    edit: function (id) {
      that.$api.industry.industryDetail(id).then((response) => {
        that.industryDialogVisinbile = true;
        that.isCreate = false;
        that.industryForm = response.data;
      });
    },
    del: function (id) {
      that
        .$confirm("确认删除", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$api.industry.delIndustry(id).then(() => {
            that.getList();
            that.$message({
              message: "删除成功",
              type: "success",
            });
          });
        })
        .catch(() => {});
    },
    checkTable: function () {
      that.getList();
    },
    submitForm: function () {
      that.$refs["subRef"].validate((valid) => {
        if (valid) {
          let _api = that.isCreate
            ? that.$api.industry.addIndustry(that.industryForm)
            : that.$api.industry.editIndustry(that.industryForm);
          _api.then((response) => {
            if (response.code == 200) {
              that.industryDialogVisinbile = false;
              that.isCreate = true;
              that.getList();
              that.$message({
                type: "success",
                message: "请求成功",
              });
              that.$refs.subRef.resetFields();
            }
          });
        }
      });
    },
  },
  beforeMount: function () {
    that = this;
  },
  mounted: function () {
    that.getList();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iot-industry-create {
  float: right;
  margin-top: 10px;
}
.iot-industry-permission {
  height: 387px;
}
.iot-search-header >>> .el-card__header {
  padding: 0 18px;
}
.iot-person >>> .el-select {
  width: 100%;
}
.page{
  display: flex;
  justify-content: flex-end;
}
</style>
